import { Dropdown, Button } from "antd";
import { DownOutlined, LogoutOutlined, KeyOutlined } from "@ant-design/icons";
import { useAuth } from "@/store/authContext";
import { useLogout } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { brand } from "@/theme";

export function TopBar() {
  const { user } = useAuth();
  const logout = useLogout();
  const nav = useNavigate();

  const initials = (user?.name || user?.email || "?")
    .split(/[\s@.]+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <header
      style={{
        height: 52,
        borderBottom: `1px solid ${brand.border}`,
        background: brand.surface,
        display: "flex",
        alignItems: "center",
        padding: "0 20px",
        justifyContent: "flex-end",
        gap: 12,
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      <Dropdown
        trigger={["click"]}
        menu={{
          items: [
            {
              key: "change-password",
              icon: <KeyOutlined />,
              label: "Change password",
              onClick: () => nav("/settings"),
            },
            { type: "divider" },
            {
              key: "logout",
              icon: <LogoutOutlined />,
              label: "Sign out",
              onClick: () => logout.mutate(),
              danger: true,
            },
          ],
        }}
      >
        <Button type="text" style={{ height: 36, padding: "0 8px" }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
            <span
              style={{
                width: 26,
                height: 26,
                borderRadius: "50%",
                background: brand.primary,
                color: "#fff",
                display: "grid",
                placeItems: "center",
                fontSize: 11,
                fontWeight: 600,
              }}
            >
              {initials}
            </span>
            <span style={{ lineHeight: 1.2, textAlign: "left" }}>
              <div style={{ fontSize: 13, fontWeight: 500, color: brand.text }}>
                {user?.name || user?.email}
              </div>
              {user?.ent && (
                <div style={{ fontSize: 11, color: brand.textMuted }}>{user.ent}</div>
              )}
            </span>
            <DownOutlined style={{ fontSize: 10, color: brand.textMuted }} />
          </span>
        </Button>
      </Dropdown>
    </header>
  );
}
